import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Trans } from 'react-i18next';

import {
    Box,
    Typography,
} from '@mui/material';

import { Close } from '@mui/icons-material';

import { setMeshId, setProjectElementId } from '../../../../store/shortcuts/Project';

import StyledPaper from '../../../styled/Paper';
import StyledIconButton from '../../../styled/IconButton';

import DefinitionList from '../../../partials/DefinitionList';

import { getSelectedObject, getSelectedObjectByID } from '../helpers';
import { setSelectedElement } from '../../../../store/actions/ScannedProject';
import store from '../../../../store';

const list = [
    { term: 'Art Number', key: 'art_number', alt: '', append: '' },
    { term: 'Description', key: 'description', alt: '', append: '' },
    { term: 'Description2', key: 'description2', alt: '', append: '' },
    { term: 'EAN', key: 'ean', alt: '-', append: '' },
    { term: 'Version', key: 'version', alt: '-', append: '' },
    { term: 'Width', key: 'width', alt: '', append: 'cm' },
    { term: 'Height', key: 'height', alt: '', append: 'cm' },
    { term: 'Depth', key: 'depth', alt: '', append: 'cm' },
];

const ElementInfoDefault = (props) => {
    const selectedMeshId = useSelector((state) => state.project.selectedMeshId);
    const selectedProjectElementId = useSelector((state) => state.project.selectedProjectElementId);
    const projectElements = useSelector((state) => state.project.elements);
    const selectedReference = useSelector((state) => state.project.selectedReference);
    const selectedObject = getSelectedObject(projectElements, selectedMeshId);

    const [selectedReferenceObject, setSelectedReferenceObject] = useState(null);

    useEffect(() => {
        if (!selectedMeshId) {
            return;
        }

        setSelectedReferenceObject(null);
    }, [selectedMeshId])

    useEffect(() => {
        if (!selectedReference) {
		setSelectedReferenceObject(null);
            return;
        }

        /*let data = getSelectedObjectByID(projectElements, selectedReference);

	if (!data) {
            data = selectedReference;
        }*/

	console.log(selectedReference);

	const data = selectedReference;

        setSelectedReferenceObject(data);
    }, [selectedReference])

    const onClose = () => {
        setMeshId(null);
        setProjectElementId(null);
    };

    return (selectedMeshId || selectedProjectElementId) && selectedObject && (
        <InfoWindow onClose={onClose} selectedObject={selectedReferenceObject ? selectedReferenceObject : selectedObject} />
    );
}

const ElementInfoScannedProjects = (props) => {
    const selectedElement = useSelector((state) => state.scannedProject.selectedElement);

    const onClose = () => {
        store.dispatch(setSelectedElement(null));
    };

    const object = selectedElement?.isFixture ? selectedElement?.element?.data ? selectedElement?.element?.data : selectedElement?.element : selectedElement?.object;

    return selectedElement && <InfoWindow onClose={onClose} selectedObject={object} />
}

const InfoWindow = (props) => {
    const { onClose, selectedObject } = props;

    return (
        <Box>
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography variant="h3">
                    <Trans>Element Information</Trans>
                </Typography>
                <StyledIconButton
                    size="small"
                    color="primary"
                    edge="end"
                    onClick={onClose}
                >
                    <Close />
                </StyledIconButton>
            </Box>
            <DefinitionList data={selectedObject} list={list} />
        </Box>
    );
}

/**
 * Element Info component
 * 
 * @returns 
 */
const ElementInfo = (props) => {
    const { type } = props;

    return type == 'scanned-projects' ? <ElementInfoScannedProjects /> : <ElementInfoDefault />;
};

export default ElementInfo;
